import React from "react";
import { useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
import { slotsData, casinoGames } from "../../lib/data/slots.data";
// import { GamesData } from "./GamesData";
import { casinoTabs } from "../../lib/data";
const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState(false);
  const totalGames = {
    ...slotsData,
    // ...casinoGames,
    ...casinoTabs.roulettetab,
    ...casinoTabs.baccarattab,
    ...casinoTabs.AndarBahartab,
    ...casinoTabs.TeenPattitab,
    ...casinoTabs.Blackjacktab,
    ...casinoTabs.thirtytwoCardtab,
    ...casinoTabs.sevenLuckytab,
    ...casinoTabs.sicbotab,
    ...casinoTabs.gameShows,
    ...casinoTabs.slotsgames,
    ...casinoTabs.indianGames,
    ...casinoTabs.spribeGames,
    ...casinoTabs.popularGames,
  };

  const handleSearch = (e) => {
    if (e) {
      setSearchText(true);

      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return (
          item.name && item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1
        );
      });
      setFilteredData(filteredValue);
    } else {
      setFilteredData([]);
      setSearchText(false);
    }
  };

  return (
    <div>
      <div className="searchGames" onClick={() => setShow(true)}>
        <p>Search Games</p>
        <BiSearch />
      </div>

      <div>
        <Modal
          show={show}
          onHide={() => {
            setFilteredData([]);
            setShow(false);
          }}
          className="searchGames1"
        >
          <Modal.Header closeButton>
            <Modal.Title>Search For Games</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <InputGroup className="mb-3 search-icon">
              <Form.Control
                placeholder="Search"
                aria-label="Text input with dropdown button"
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                // style={{ color: "#000" }}
                autoFocus
              />
            </InputGroup>
            <div className="GamesShow">
              {filteredData &&
                filteredData.map((item) => (
                  <div className="displayGames">
                    <a href={item.redirectUrl || item.href}>
                      {item.imgUrl ? (
                        <img src={item.imgUrl} />
                      ) : (
                        <img src={item?.cover?.src} />
                      )}
                    </a>
                  </div>
                ))}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default GamesSearchModal;
